let actions = null
const registerActions = (storeActions) => actions = storeActions
const turnOnBackdrop = (element, item, blocking = true) => {
    if (!actions) console.warn('Backdrop actions not registered')
    actions?.activateBackdrop({ element, item, blocking })
}
const turnOffBackdrop = () => {
    if (!actions) console.warn('Backdrop actions not registered')
    actions?.deactivateBackdrop()
}
export const backdrop = {
    turnOnBackdrop,
    turnOffBackdrop,
    registerActions,
}
